<script>

import { Doughnut } from 'vue-chartjs'
import store from 'vuex-store'
import urlApi from '../../../../router/urlApi'
import Vue from 'vue'

let palette = store.getters.palette

export default {
  extends: Doughnut,
  data () {
    return {
      chartData: {
        labels: ['Aulas Feitas',	'Aulas Faltantes'],
        datasets: [{
          backgroundColor: [palette.primary],
          data: [0,	0]
        }]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            fontColor: palette.fontColor,
            fontFamily: 'sans-serif',
            fontSize: 13,
            usePointStyle: true
          }
        },
        tooltips: {
          bodyFontSize: 15,
          bodyFontFamily: 'sans-serif'
        },
        responsive: true,
        maintainAspectRatio: false,
        fontSize: 20
      }
    }
  },
  async mounted () {
    await Vue.http.get(urlApi + '/ead/profile').then((response) => {
      this.chartData.datasets[0].data[0] = response.body.aulas_praticas.presencas_aulas_praticas
    })

    this.renderChart(this.chartData, this.options)
  }

}
</script>
